import {
  LineStateStatusType,
  CouponStatusType,
  DiscountCodeProductLimit,
  DiscountCodePurchaseLimit,
} from "../enums/index";
class Headings {
  LinesHeading = "لیست خط‌ها";
  LinesTableHeading = [
    "شماره خط",
    "روشن/خاموش",
    "بسته متصل",
    "سرویس فعلی",
    "وضعیت خرید",
    "تاریخ شروع",
    "تاریخ پایان",
    "فعال‌سازی",
  ];
  SearchTableHeading = [
    "ردیف",
    "نام و نا‌م‌خانوادگی",
    "احراز هویت",
    "شماره موبایل",
    "آدرس ایمیل",
  ];
  SearchTableHeadingInReady = [
    "ردیف",
    "نام و نا‌م‌خانوادگی",
    "احراز هویت",
    "شماره موبایل",
    "آدرس ایمیل",
    "تاریخ آپلود کارت ملی",
  ];
  SearchTableHeadingInAccepted = [
    "ردیف",
    "نام و نا‌م‌خانوادگی",
    "احراز هویت",
    "شماره موبایل",
    "آدرس ایمیل",
    "تاریخ آپلود کارت ملی",
    "تاریخ احراز هویت",
  ];
  SecretaryTabTitle = "منشی مجازی";
  IVRTabTitle = "تلفن گویا";
  FaxTabTitle = "فکس";
  CurrentPeriod = "دوره جاری";
  Lines = "خط‌ها";
  ServicesTabHeader = [
    "اطلاعات بسته",
    "خط‌های متصل",
    "مدت",
    "وضعیت",
    "اپراتور بسته",
    "شروع سرویس",
    "پایان سرویس",
  ];
  ServicesHistory = "تاریخچه سرویس‌ها";
  ServicesIVRTabHeader = [
    "اطلاعات بسته",
    "خط‌های متصل",
    "مدت",
    "وضعیت",
    "شروع سرویس",
    "پایان سرویس",
  ];
  CurrentService = "سرویس جاری";
  TransactionTitle = "لیست تراکنش‌ها";
  TransactionHeader = [
    "تاریخ فاکتور",
    "تاریخ تراکنش",
    "شرح",
    "وضعیت",
    "در‌گاه پرداخت",
    "کد تخفیف",
    "مبلغ",
    "تخفیف",
    "مالیات",
    "پرداخت‌ شده",
    "گزینه‌ها"
  ];
  AuthPageTitle = "احراز هویت";
  NoAuthAllowance = " این کاربر شرایط احراز هویت را ندارد";
  AuthHistoryTableHeading = ["زمان", "کاربر", "نتیجه", "جزییات درخواست"];
  AuthTableTitle = "تاریخچه";
  UserInfoTitle = " اطلاعات کاربر";
  UserInfoTitlePartOne = "اطلاعات شخصی";
  UserInfoTitlePartTwo = "اطلاعات تماس";
  UserInfoTitlePartTHree = "اطلاعات شرکت";
  YouAreNotLogin = "برای دیدن این صفحه باید لاگین کنید";
  userDropDown = "حساب کاربری";
  logOut = "خروج";
  NotValidBrowser =
    "برای استفاده از این سرویس فقط می‌توانید از کروم ورژن ۹۰ به بالا استفاده کنید";
  YouAreWatching = "مشترک مورد مشاهده شما";
  InquiryRequestTitle = "جزییات درخواست";
  ActiveLinesTitle = "خط‌های جاری";
  LinesHistoryTitle = "تاریخچه خط‌ها";
  ActivateLinesPageTitle = "فعالسازی خطوط";
  RejectLinesPageTitle = "عدم‌فعالسازی خطوط";
  ActivateLinesPageTableTitle = [
    "ردیف",
    "شماره",
    "مشترک",
    "وضعیت احراز هویت",
    "تاریخ اختصاص خط",
  ];
  RejectLinesPageTableTitle = [
    "ردیف",
    "شماره",
    "مشترک",
    "وضعیت احراز هویت",
    "تاریخ عدم فعال‌سازی ",
    "دلیل عدم فعال‌سازی ",
  ];
  LoginAsUser = "Login as";
  EditAddress = "ویرایش"
  EditAddressSave = "ذخیره‌سازی"
  cancleEditSave = "انصراف"
  ExtendeLines = "خط‌های تمدیدی";
  PLEASE_SELECTION = " انتخاب کنید..."
  PLEASE_SELECTION_PROVINCE = "ابتدا استان را انتخاب کنید ...."
  LinesTableHistoryHeading = [
    "شماره خط",
    "بسته متصل",
    "وضعیت خرید",
    "تاریخ شروع",
    "تاریخ پایان",
    "فعال‌سازی",
  ];
  LinesTableExtendedHeading = [
    "شماره خط",
    "بسته متصل",
    "تاریخ شروع",
    "تاریخ پایان",
  ];
  ServiceLinesHeading = "خط‌های مرتبط";
  ServiceLinesTableHeading = [
    "شماره خط",
    "روشن/خاموش",
    "بسته متصل",
    "سرویس فعلی",
  ];
  RejectReasonModalTitle = "ثبت دلیل رد هویت مشترک";
  NotesTitle = "یادداشت‌ها";
  ChangeEmailByAdmin = "تغییر آدرس توسط ادمین"
  UserAddress = "آدرس کاربر"
  From = "از"
  PostalCode = "کد پستی"
  HouseNumber="پلاک"
  To = "به"
  Change = "تغییر یافت"
  RejectActivationReasonModalTitle = "ثبت دلیل عدم فعال سازی خط";
  ServiceUserActionHistoryHeading = "تاریخچه تغییرات";
  ServiceUserActionHistoryTableHeading = ["زمان", "کاربر", "توضیحات"];
  LinesDropDownItemsText(type) {
    let result = "";
    if (type === LineStateStatusType.Active()) result = "آماده فعال‌سازی";
    if (type === LineStateStatusType.RejectActivation())
      result = "عدم فعال سازی شده";

    return result;
  }
  LinesDropDownItems = ["آماده فعال‌سازی", "عدم فعال سازی شده"];
  PromotionTableHeading = [
    "ردیف",
    "کد",
    "درصد",
    "سقف مبلغ",
    "سقف تعداد",
    "وضعیت",
    "تاریخ ایجاد",
    "تاریخ انقضا",
  ];
  Success = "موفق"
  Failed = "ناموفق"
  ChangeEmailTableHeading = [
    "ردیف",
    "مشترک",
    "از ایمیل",
    "به ایمیل",
    "ویرایش در هلپی‌کال",
    "تاریخ تغییر",
    "گزینه‌ها",
  ];
  options = "مشاهده"
  ReportFrom = "از تاریخ"
  ReportTo = "تا تاریخ"
  NoData = "در تاریخ انتخاب شده اطلاعات وجود ندارد!"
  PromotionDetailsTableHeading = [
    "درصد",
    "سقف مبلغ",
    "سقف تعداد",
    "تعداد استفاده",
    "مبلغ استفاده",
    "نوع سرویس",
    "نوع مشترکین",
    "تاریخ ایجاد",
    "تاریخ انقضا",
  ];
  CouponDropDownItemsText(type) {
    let result = "";
    if (type === CouponStatusType.Active()) result = "کدهای فعال";
    if (type === CouponStatusType.Expired()) result = "کدهای غیرفعال";

    return result;
  }
  CouponProductLimitText(type) {
    let result = "";
    if (type === DiscountCodeProductLimit.AllProducts()) result = "همه محصولات";
    if (type === DiscountCodeProductLimit.CertainProduct()) result = "بسته خاص";
    if (type === DiscountCodeProductLimit.CertainProduct()) result = "بسته خاص";
    if (type === DiscountCodeProductLimit.IvrOnly()) result = "تلفن گویا";
    if (type === DiscountCodeProductLimit.SecretaryOnly())
      result = "منشی  مجازی";
    if (type === DiscountCodeProductLimit.FaxOnly()) result = "فکس اینترنتی";
    if (type === DiscountCodeProductLimit.LineOnly()) result = "خط";
    return result;
  }
  CouponPurchaseLimitText(type) {
    let result = "";
    if (type === DiscountCodePurchaseLimit.AllPurchasesAllowed())
      result = "همه مشترکین";
    if (type === DiscountCodePurchaseLimit.FirstPurchaseOnly())
      result = "اولین خرید";
    if (type === DiscountCodePurchaseLimit.ExtendOnly()) result = "تمدید سرویس";
    if (type === DiscountCodePurchaseLimit.ReturningCustomerOnly())
      result = "مشترکین بازگشتی";
    return result;
  }
  CouponDropDownItems = ["کد‌های فعال", "کدهای غیرفعال"];
  CouponCreateBtn = "ایجاد کد تخفیف";
  CouponModalTitle = "کد تخفیف جدید";
  CouponExtendBtn = "تمدید مهلت";
  CouponDisableBtn = "غیر فعال‌سازی";
  CouponEnableBtn = "فعال‌سازی";
  CodeDetails = "مشخصات کد";
  Gender = "جنسیت";
}
export default new Headings();
